import type { ChipJSON } from './model/types'
import type { VoronoiCompensationData } from './builder/shapes/voronoiCompensation'

export const JSCAD_SHAPE_THRESHOLD = 200

export function countModelShapes(
  chipJSON: ChipJSON,
  voronoiCompensationData?: VoronoiCompensationData[]
): number {
  let count = chipJSON.crosslayerConnections.reduce(
    (total, connection) => total + connection.shapes.length,
    0
  )

  for (const layer of chipJSON.layers) {
    if (layer.compensation) count++
    for (const channel of layer.channels) count += channel.shapes.length
    for (const component of layer.components) {
      count += component.shapes.length
      for (const channel of component.channels) count += channel.shapes.length
    }
  }

  if (voronoiCompensationData) {
    count += voronoiCompensationData.reduce(
      (total, elevation) => total + elevation.regions.filter(
        region => region.polygon.length >= 3 && region.compensation > 0
      ).length,
      0
    )
  }

  return count
}

export function isLargeModel(
  chipJSON: ChipJSON,
  voronoiCompensationData?: VoronoiCompensationData[]
): boolean {
  return countModelShapes(chipJSON, voronoiCompensationData) >= JSCAD_SHAPE_THRESHOLD
}
